import { Text } from 'stubben-edge-unified-frontend-react-components';
import { formatCampaignListMetricRate } from '../utils/campaignListUtils';

type CampaignListMetricCellProps = {
  count?: number;
  rate?: number;
};

function CampaignListMetricCell({ count, rate }: CampaignListMetricCellProps) {
  if (count == null || rate == null) {
    return <>—</>;
  }

  return (
    <div className="flex flex-col gap-0.5">
      <Text size="sm">{count}</Text>
      <Text size="xs" variant="quaternary">
        {formatCampaignListMetricRate(rate)}
      </Text>
    </div>
  );
}

export default CampaignListMetricCell;
